const Color = {
  // Flip Orange
  flipOrangePlus2: '#7E3221',
  flipOrangePlus1: '#D35437',
  flipOrange: '#FD6542',
  flipOrangeMin1: '#FE9881',
  flipOrangeMin2: '#FEC1B3',
  flipOrangeMin3: '#FDEAE6',
  // Yellow
  yellowPlus2: '#543D07',
  yellowPlus1: '#A87A0D',
  yellow: '#FCB714',
  yellowMin1: '#FDCF62',
  yellowMin2: '#FEE7B1',
  yellowMin3: '#FEF1D0',
  // Pink
  pinkPlus2: '#8A1A38',
  pinkPlus1: '#C61F4D',
  pink: '#EE255C',
  pinkMin1: '#F46E92',
  pinkMin2: '#F9B6C9',
  pinkMin3: '#FCD8E1',
  pinkMin4: '#F4FBFF',
  // Crimson Red
  crimsonRedPlus2: '#8A1A38',
  crimsonRedPlus1: '#C61F4D',
  crimsonRed: '#EE255C',
  crimsonRedMin1: '#F46E92',
  crimsonRedMin2: '#F9B6C9',
  crimsonRedMin3: '#FDE9EF',
  // Other Red
  brightMaroon: '#C61F4D',
  paleRed: '#D35437',
  // Green
  greenPlus2: '#17403A',
  greenPlus1: '#2F7F74',
  green: '#46BFAE',
  greenMin1: '#84D4C9',
  greenMin2: '#C1EAE4',
  greenMin3: '#DAF2EF',
  //Golden
  goldenYellowMin2: '#FEE7B1',
  goldenYellowMin3: '#FDF6DC',
  goldenYellowPlus2: '#543D07',
  // Jade Green
  jadeGreenPlus2: '#236057',
  jadeGreenPlus1: '#2F7F74',
  jadeGreen: '#46BFAE',
  jadeGreenMin1: '#84D4C9',
  jadeGreenMin2: '#C1EAE4',
  jadeGreenMin3: '#DAF2EF',
  jadeLight: '#E9FFF8',
  // Purple
  purplePlus2: '#3B0A2D',
  purplePlus1: '#75135B',
  purple: '#B01D88',
  purpleMin1: '#CA68B0',
  purpleMin2: '#E5B4D7',
  purpleMin3: '#EFD2E7',
  // Blue
  bluePlus2: '#223547',
  bluePlus1: '#446A8F',
  blue: '#5786CC',
  blueMin1: '#99BFE4',
  blueMin2: '#CCDFF1',
  blueMin3: '#E0ECF7',
  aliceBlue: '#F4FBFF',
  // Sapphire Blue
  sapphireBluePlus2: '#1D2D44',
  sapphireBluePlus1: '#3A5988',
  sapphireBlue: '#5785CC',
  sapphireBlueMin1: '#8FAEDD',
  sapphireBlueMin2: '#C7D7EE',
  sapphireBlueMin3: '#DDE7F5',
  // Grey
  greyPlus2: '#222223',
  greyPlus1: '#555556',
  grey: '#AAABAD',
  greyMin1: '#C6C7C8',
  greyMin2: '#E3E3E4',
  greyMin3: '#EEEEEF',
  lightGrey: '#DEDEDE',
  darkGrey: '#A9A9A9',
  greyPlaceholder: '#A4A4A4',
  // Etc
  blackBekko: '#333333',
  lightAnemia: '#FFF5F3',
  lightSmoke: '#F9F9F9',
  freshWater: '#F3F7F9', //background
  ketchupTomato: '#D42E52',
  transparent: 'transparent',
  specialWidget: '#EB451E70',
  // Neutral
  mainText: '#222223',
  secondaryText: '#747474',
  borderDisabled: '#E3E3E4',
  containerSecond: '#F3F5F6',
  disabled: '#E3E3E4',
  container: '#F3F5F6',
  white: '#FFFFFF',
  black: '#000000',
  solidGrey: '#e8e8e8',
  customBlack30Percent: 'rgba(0, 0, 0, 0.3)',
  customBlack80Percent: 'rgba(0, 0, 0, 0.8)',
  customShadowGrey: '#B5B5B5',
  greyLight: '#E5E5E5',
  overlay70: 'rgba(34, 34, 35, 0.7)',
};

export default Color;
